/**
 * @file messages.ts
 *
 * @fileoverview Services for registering messages.
 */

import { Message } from '~/jobiqo/models/app';

let messages: Message[] = [];

/**
 * Inserts a new message into the global store.
 *
 * @param {Message} message
 *   The message to send.
 */
export const addServerMessage = (message: Message) => {
  messages = [...messages, message];
};
export const clearMessages = () => (messages = []);
export const getMessages = (): Message[] => messages;
